export function getUniqueName() {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < 20) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function getDateOfBirth(randomNumber: number, daysBefore: number) {
  const currentYear = new Date().getFullYear();
  const eligibleAdultAge = new Date(currentYear - 18, 0, 1);

  return new Date(
    eligibleAdultAge.getTime() + randomNumber * daysBefore * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export function pickRandom(list: string[], randomNumber: number) {
  return list[Math.floor(randomNumber * list.length)];
}

export function getRandomDemographicInfo() {
  const randomMathNumber = Math.random();
  const customerDemographic: { [key: string]: any } = {};
  customerDemographic.firstName = getUniqueName();
  customerDemographic.lastName = getUniqueName();
  customerDemographic.gender = pickRandom(["Male", "Female"], randomMathNumber);
  customerDemographic.dateOfBirth = getDateOfBirth(randomMathNumber, -1000);

  return customerDemographic;
}
